import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { history, Role } from '../../../../helpers';

class HomeBanner extends Component {

    constructor(props) {

        super(props);
        // reset login status
        this.state = {
            loggedIn: props.authentication.loggedIn,
            formField: {
                subject: '',
                location: '',
                category_id: '',
            },
        };
    }

    handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        let formField = { ...this.state.formField };
        if (name === 'subject') {
            const { categories } = this.props;
            const cateArray = categories && categories.data ? categories.data.filter(el => el.id === parseInt(value)) : [];
            const cate = cateArray && cateArray[0];
            formField['subject'] = cate.name;
        } else {
            formField[name] = (type === 'checkbox') ? (checked === true) ? 1 : '' : value;
        }
        this.setState({ formField });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { formField } = this.state;
        history.push({
            pathname: `/search-tutors`,
            state: { formField }
        });
    }

    render() {
        const { cateArray, authentication } = this.props;
        const user = authentication && authentication.authentication && authentication.authentication.user;

        return (<section className="home-banner mb-5">
            <div className="image">
                <img className="img-fluid" src="/images/svg/banner-svg.svg" alt="Banner" />
            </div>
            <div className="caption">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8">
                            <h2>The trusted way to find a tutor</h2>
                            <h4>Private, 1–on–1 lessons with the Tutor of your choice.</h4>

                            <div className={`search-box ${(user && user.role === Role.Tutor) ? 'd-none' : ''}`}>
                                <form name="home" onSubmit={this.handleSubmit} noValidate>
                                    <div className="form-row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                {/* <input type="text" className="form-control" name="subject" placeholder="Enter Subject/Topic"  onChange={this.handleChange} /> */}
                                                <select className="form-control custom-select" name="subject" onChange={this.handleChange}>
                                                    <option value="">Select</option>
                                                    {cateArray && cateArray.map(item => <option key={`cat-${item.id}`} value={item.id}>{item.name}</option>)}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-5">
                                            <div className="form-group">
                                                <input type="text" className="form-control" name="location" placeholder="Zip code or Location" onChange={this.handleChange} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <button type="submit" className="btn btn-primary">FIND A TUTOR</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>);
    }
}

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const categoriesSelector = createSelector(
    state => state.categories,
    categories => categories
);

const mapStateToProps = createSelector(
    authenticationSelector,
    categoriesSelector,
    (authentication, categories) => ({
        authentication, categories
    })
);

export default connect(mapStateToProps)(HomeBanner);
